import { combineReducers } from 'redux';

import stats from './stats/reducer';
import topProducts from './topProducts/reducer';

export default combineReducers({
  stats,
  topProducts,
});
